import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppscriptsSetting, AppscriptsSettingUpdate } from '../models/appscripts-setting.model';
import { RestUtils } from './rest-utils';
declare const moment: any;

@Injectable()
export class AppscriptsSettingService {
  http: HttpClient;

  utils = new RestUtils();

  headers = new HttpHeaders();

  constructor(http: HttpClient) {
    this.http = http;
    this.headers = this.headers.set('Content-Type', 'application/json');
  }

  all(): Observable<AppscriptsSetting[]> {
    const url = this.utils.buildUrl('ROLE/appscr/data/settings');
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.get<AppscriptsSetting[]>(url, options);
  }

  save(settings: AppscriptsSettingUpdate[]): Observable<void> {
    const url = this.utils.buildUrl('ROLE/appscr/data/settings');
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.put<void>(url, settings, options);
  }
}
